










































import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    ServerError: () => import('@/components/forms/ServerError.vue'),
  },
})
export default class PageInvitesShow extends Vue {
  @Getter('role/all') roles!: () => Promise<Role[]>;

  @Action('invite/create') createInvite!: (payload: Invite) => Promise<Invite>;

  i18n: string = 'views.accounts.invite';

  $refs!: Vue['$refs'] & {
    inviteForm: FormClass;
  };

  formLoaded: boolean = false;

  payload: Invite = {
    email: '',
    first_name: '',
    last_name: '',
    locale: 'nl_BE',
    roles: [],
    reseller_id: null,
  };

  private handleSubmit() {
    // @ts-ignore
    this.createInvite(this.payload)
      .then((invite: Invite) => {
        this.$refs.inviteForm.handleSuccess();
        this.$router.push({ name: 'accounts' });
      })
      .catch((e: ErrorResponse) => this.$refs.inviteForm.handleErrors(e));
  }
}
